// Material Dashboard 2 React layouts
import ProfileOverview from "layouts/pages/profile/profile-overview";
import AllProjects from "layouts/pages/profile/all-projects";
import NewUser from "layouts/pages/users/new-user";
import Settings from "layouts/pages/account/settings";
import Billing from "layouts/pages/account/billing";
import Invoice from "layouts/pages/account/invoice";
import Timeline from "layouts/pages/projects/timeline";
import PricingPage from "layouts/pages/pricing-page";
import Widgets from "layouts/pages/widgets";
import RTL from "layouts/pages/rtl";
import Charts from "layouts/pages/charts";
import Notifications from "layouts/pages/notifications";
import Kanban from "layouts/applications/kanban";
import Wizard from "layouts/applications/wizard";
import DataTables from "layouts/applications/data-tables";
import Calendar from "layouts/applications/calendar";
import NewProduct from "layouts/ecommerce/products/new-product";
import ProductPage from "layouts/ecommerce/products/product-page";
import OrderList from "layouts/ecommerce/orders/order-list";
import OrderDetails from "layouts/ecommerce/orders/order-details";
import SignInBasic from "layouts/authentication/sign-in/basic";
import SignInCover from "layouts/authentication/sign-in/cover";
import SignInIllustration from "layouts/authentication/sign-in/illustration";
import SignUpCover from "layouts/authentication/sign-up/cover";
import ResetCover from "layouts/authentication/reset-password/cover";
import MDAvatar from "components/MDAvatar";
import Icon from "@mui/material/Icon";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import Person4Icon from '@mui/icons-material/Person4';
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import CategoryIcon from '@mui/icons-material/Category';
import CollectionsIcon from '@mui/icons-material/Collections';
import DashboardCustomizeIcon from '@mui/icons-material/DashboardCustomize';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import profilePicture from "assets/images/team-3.jpg";
import Product from "layouts/products/Product"
import Logout from "layouts/vendor/Logout";
import ProtectedRoute from "routes/ProtectedRoute";
import Profile from "layouts/vendor/Profile";
import WithdrawalConfiguration from "layouts/vendor/WithdrawalConfiguration";
import ManageWithdrawals from "layouts/vendor/ManageWithdrawals";
import ChangePassword from "layouts/vendor/ChangePassword";
import ProductManage from "layouts/products/Manage";
import Dashboard from "layouts/dashboard";
import List from "layouts/order/List";
import Pickup from "layouts/order/Pickup";
import PickupLocation from "layouts/vendor/PickupLocation";
import ManageTickets from "layouts/tickets/ManageTickets";
import ReturnRequests from "layouts/returnRequest/List";
import Service from "layouts/services/Service";
import ServiceManage from "layouts/services/Manage";

const vendorName=localStorage.getItem('name');

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    route: "/dashboard",
    component: <ProtectedRoute check="logout"><Dashboard /></ProtectedRoute>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: vendorName,
    key: "Vendor",
    icon: <MDAvatar src={profilePicture} alt="Vendor" size="sm" />,
    collapse: [
      {
        name: "My Profile",
        key: "my-profile",
        route: "/vendor/profile",
        component: <ProtectedRoute check="logout"><Profile name="profile"/></ProtectedRoute>,
      },
      {
        name: "Withdrawal Configuration",
        key: "withdrawal-configuration",
        route: "/vendor/withdrawalConfiguration",
        component: <ProtectedRoute check="logout"><WithdrawalConfiguration /></ProtectedRoute>,
      },
      {
        name: "Pickup Location",
        key: "pickup-location",
        route: "/vendor/pickupLocation",
        component: <ProtectedRoute check="logout"><PickupLocation /></ProtectedRoute>,
      },
      {
        name: "Change Password",
        key: "change-password",
        route: "/vendor/changePassword",
        component: <ProtectedRoute check="logout"><ChangePassword name="changePassword"/></ProtectedRoute>,
      },
      {
        name: "Logout",
        key: "logout",
        route: "/vendor/logout",
        component: <ProtectedRoute check="logout"><Logout name="logout"/></ProtectedRoute>,
      }
    ],
  },
  { type: "divider", key: "divider-0" },  
  {
    type: "collapse",
    name: "Products",
    key: "products",
    icon: <Icon fontSize="small">category</Icon>,
    collapse: [
      {
        name: "Manage Products",
        key: "manage",
        route: "products/manage",
        component: <ProtectedRoute check="logout"><ProductManage /></ProtectedRoute>,
      },
      {
        name: "Add Product",
        key: "add",
        route: "products/addProduct",
        component: <ProtectedRoute check="logout"><Product /></ProtectedRoute>,
      }
    ],
  },
  {
    type: "collapse",
    name: "Services",
    key: "services",
    icon: <Icon fontSize="small">category</Icon>,
    collapse: [
      {
        name: "Manage Service",
        key: "manage",
        route: "services/manage",
        component: <ProtectedRoute check="logout"><ServiceManage /></ProtectedRoute>,
      },
      {
        name: "Add Service",
        key: "add",
        route: "services/add",
        component: <ProtectedRoute check="logout"><Service /></ProtectedRoute>,
      }
    ],
  },
  {
    type: "collapse",
    name: "Orders",
    key: "manage-orders",
    icon: <Icon fontSize="medium">shopping_basket</Icon>,
    route: "/order/list",
    component: <ProtectedRoute check="logout"><List /></ProtectedRoute>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Return Requests",
    key: "return-requests",
    icon: <AssignmentReturnIcon />,
    route: "/returnRequests/list",
    component: <ProtectedRoute check="logout"><ReturnRequests /></ProtectedRoute>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Pickup Requests",
    key: "manage-pickup",
    icon: <Icon fontSize="medium"><LocalShippingIcon /></Icon>,
    route: "/order/pickup",
    component: <ProtectedRoute check="logout"><Pickup /></ProtectedRoute>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Manage Withdrawals",
    key: "manage-withdrawals",
    icon: <Icon fontSize="medium">redeem</Icon>,
    route: "/withdrawal/list",
    component: <ProtectedRoute check="logout"><ManageWithdrawals /></ProtectedRoute>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Manage Tickets",
    key: "manage-tickets",
    icon: <Icon fontSize="medium">redeem</Icon>,
    route: "/tickets/list",
    component: <ProtectedRoute check="logout"><ManageTickets /></ProtectedRoute>,
    noCollapse: true,
  },

];

export default routes;
